import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhyItFailedSection() {
  const reasons = ["La 'fuerza de voluntad' es un recurso biológico agotable que la depresión consume primero.", 'Los consejos motivacionales ignoran que tu cuerpo necesita seguridad física, no gritos de aliento.', "Intentar salir de la cama por 'culpa' aumenta el cortisol, lo que genera más parálisis y bloqueo.", 'La disciplina humana sin la Gracia Operativa es como intentar mover una montaña con las manos vacías.'];
  return <section className="py-12 md:py-14 px-6 bg-cream" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        <FadeIn data-id="element-193">
          <h2 className="font-serif text-2xl md:text-3xl text-navy mb-6 text-center" data-id="element-194">
            Por qué lo que has intentado no funcionó
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-195">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-196">
              <div className="flex items-start gap-3 p-4 bg-white rounded-xl shadow-sm border border-divider/50" data-id="element-197">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-sage/20 flex items-center justify-center mt-0.5" data-id="element-198">
                  <svg className="w-3.5 h-3.5 text-sage" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-199">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-200" />
                  </svg>
                </div>
                <p className="text-base text-navy/80 leading-relaxed" data-id="element-201">
                  {reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}